import { brownLogisticsType } from "@reducers/actionTypes";
import { asyncActionCreator } from "./redux.action";

const getBrownLogisticsType = asyncActionCreator(
  brownLogisticsType.GET_CONFIG_DATA_UPCOMING,
  brownLogisticsType.GET_CONFIG_DATA_SUCCESS,
  brownLogisticsType.GET_CONFIG_DATA_ERROR,
  brownLogisticsType.GET_CONFIG_DATA_FETCHED,
);

export default {
  getBrownLogisticsType,
};
